var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeptrail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 235,
    viewBox: "0 0 183 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.0887 170.101L68.1362 170.11L95.722 142.524L114.508 142.54",
    stroke: "#C1D8EB",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.339 79.9427L75.2054 79.8986L45.0239 49.7172L3.33506 49.682L-29.5258 82.5429",
    stroke: "#C1D8EB",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.451 113.126L87.5516 113.104L80.4868 120.169L35.2674 120.131L21.6648 133.733",
    stroke: "#C1D8EB",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.324 105.939L56.5459 105.886L45.1533 94.4936L-3.82463 94.4523L-10.7203 101.348",
    stroke: "#C1D8EB",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.971 134.207L77.4825 134.184L50.8502 160.816L5.76109 160.778",
    stroke: "#C1D8EB",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.867 161.371L103.486 161.352L91.6535 173.185",
    stroke: "#C1D8EB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M138.614 174.671L121.7 174.653L112.234 184.12",
    stroke: "#C1D8EB",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeptrail);
export default __webpack_public_path__ + "static/media/heptrail.6c09da87e8a03e52b4bb599c7e88b21f.svg";
export { ForwardRef as ReactComponent };